import React, { useEffect } from 'react';
import Contactbanner from '../Mencontactus/Contactbanner';
import Bredcrumb from '../Bredcrumb/Main';
import BannerContact from '../../assets/images/background/banner-contact.jpg';
import { Helmet } from 'react-helmet';
import ReactPixel from 'react-facebook-pixel';

function Main() {
  useEffect(() => {
    ReactPixel.init('1727601077676996');
    ReactPixel.pageView();
  }, []);

  return (
    <>
      <Helmet>
        <meta name='description' content='Discover authentic Indian cuisine in Alexandria, Canada. Experience vibrant flavors, exceptional service, and find us easily on Google Maps.' />
        <meta name="title" content="About Naans by Shubi / The Atlantic PUb, Alexandia, Canada" />
      </Helmet>
      <Bredcrumb
        title="ANY QUERY ?"
        subtitle="Contact Us"
        Img={BannerContact}
      />

      <Contactbanner />
    </>
  );
}

export default Main;
